export default __webpack_public_path__ + "static/media/sound_of_water.6f6a62fa.png";